import classes from './LoginPage.module.scss'
import { Form } from 'react-bootstrap'
import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useAppDispatch } from '../../../shared/lib/hooks/useAppDispatch/useAppDispatch'
import { loginMFA } from '../model/services/loginMFA'
import { useLocation, useNavigate } from 'react-router-dom'
import { RoutePath } from '../../../shared/config/routeConfig/routeConfig'
import { useAppSelector } from '../../../shared/lib/hooks/useAppSelector/useAppSelector'
import { selectMfaData } from '../model/selectors/selectMfaData'
import { loginActions } from '../model/slices/loginSlice'
import { selectOtpCode } from '../model/selectors/selectOtpCode'
import { selectError } from '../model/selectors/selectError'
import { mfaErrors } from '../model/types/mfaErrors'
import { selectMfaLoading } from '../model/selectors/selectMfaLoading'
import { ResendOtpBtn } from './components/ResendOtpBtn'
import { classNames } from '../../../shared/lib/classNames/classNames'
import { MfaHelpInfo } from './components/MfaHelpInfo'
import { LAST_MFA_DATA } from '../model/lib/consts'
import Box from '@mui/material/Box'

export const MfaForm = () => {
	const dispatch = useAppDispatch()
	const navigate = useNavigate()
	const location = useLocation()
	const { reset } = useForm<{ otpCode: string }>({ mode: 'onBlur' })
	const mfaDataFromSS = JSON.parse(sessionStorage.getItem(LAST_MFA_DATA) || '')
	const mfaData = useAppSelector(selectMfaData) ?? mfaDataFromSS
	const otpCode = useAppSelector(selectOtpCode)
	const mfaLoading = useAppSelector(selectMfaLoading)
	const error = useAppSelector(selectError)

	const mods = {
		[classes[error?.errorStatus ?? '']]: true,
		[classes['verifying']]: mfaLoading,
		[classes['default']]: error?.message && !error?.errorStatus

	}
	const inputMods = {
		[classes[error?.errorStatus + '_input' ?? '']]: true,
		[classes['verifying_input']]: mfaLoading
	}

	const onSubmit = async (otpCodeValue: string) => {
		const result = await dispatch(loginMFA({
			challengeId: mfaData?.mfa?.challengeId ?? '',
			otpCode: otpCodeValue
		}))
		if (result.meta.requestStatus === 'fulfilled') {
			const fromLocation = location.state?.from?.pathname
			fromLocation ? navigate(`${fromLocation}`) : navigate(RoutePath.profile)
			reset()
		}
	}

	const handleOtpCodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (error) dispatch(loginActions.resetError())

		const value = event.target.value
		const sixCharValue = value.trim().length > 6 ? value.slice(0, 6) : value
		const onlyDigitsRegex = /^\d*$/

		if (onlyDigitsRegex.test(sixCharValue)) {
			dispatch(loginActions.setOtpCode(sixCharValue))
		}
		if (sixCharValue && /^\d{6}$/.test(sixCharValue)) {
			onSubmit(sixCharValue).then(console.log).catch(console.error)
		}
	}

	useEffect(() => {
		if (error && error.errorStatus === mfaErrors.OTP_INVALID) {
			setTimeout(() => {
				dispatch(loginActions.setOtpCode(''))
			}, 1000)
		}
		if (error && (
			error.errorStatus === mfaErrors.INVALID_CHALLENGE ||
			error.errorStatus === mfaErrors.TOO_MANY_ATTEMPTS
		)) {
			setTimeout(() => {
				navigate(RoutePath.login)
			}, 3000)
		}
	}, [error, navigate])

	useEffect(() => {
		return () => {
			dispatch(loginActions.setOtpCode(''))
		}
	}, [])

	return (
		<div
			className={classes['form-content']}
		>
			<Form>
				<h3 className="mb-4">Additional authentication</h3>

				<div className="mb-4">
					We have sent a 6-digit code to your email
					<div>
						<b>{mfaData?.mfa?.maskedDestination ?? '*****@tools4brokers.com'}</b>
					</div>
				</div>
				<Form.Group
					className={classes['login-input']}
					controlId="login-input"
				>
					<Form.Label>6-digit code</Form.Label>
					<Form.Control
						className={classNames('', inputMods, [])}
						autoFocus
						type="text"
						value={otpCode}
						placeholder="Verification code"
						onChange={handleOtpCodeChange}
						disabled={mfaLoading}
					/>
					{(mfaLoading || error?.message) && (
						<Box component={'span'}
						     className={classNames(classes.feedback, mods, [])}>
							{mfaLoading ? 'Verifying code...' : error?.message ? error?.message : ''}
						</Box>
					)}
				</Form.Group>
			</Form>
			<ResendOtpBtn />
			<MfaHelpInfo />
		</div>
	)
}